import { SupportSkills } from '../models/SupportSkills';

export const getIncompleteSkills = (skills: SupportSkills[]) => {
  return (
    skills
      .filter(
        skill =>
          skill.skillSubstate?.skillState?.id !== 'SkillStateNode:3' &&
          skill.skillSubstate?.skillState?.id !== 'SkillStateNode:4',
      )
      .sort((a, b) => (a.readinessScore || 0) - (b.readinessScore || 0)) || []
  );
};
